import { useEffect, useState } from "react";
import { nanoid } from "nanoid";
import Button from "../../Button";
import IconButton from "../../CommonComponents/IconButton";
import InputField from "../../CommonComponents/InputField";
import useAxiosPrivate from "../../../Hooks/useAxiosPrivate";
import { complexityid, libTypeIds, RESULT_STATUS } from "../../../constants";
import ConfigureTopic from "./ConfigureTopic";
import { LANG_ID } from "../../../constants";
import Toast from "../../CommonComponents/Toast";
import useAuth from "../../../Hooks/useAuth";
import Modal from "../../CommonComponents/Modal";
import ModalBody from "../../CommonComponents/ModalBody";
import Tooltip from "../../CommonComponents/Tooltip";
// import { useDebouncedValue } from "../../../Hooks/useDebounceValue";
const difficulties = Object.entries(complexityid).map(([label, value]) => ({
  value,
  label,
}));
const languages = Object.entries(LANG_ID).map(([label, value]) => ({
  value,
  label,
}));

const descTypes = [
  {
    value: libTypeIds.SAQ,
    label: "SAQ",
  },
  {
    value: libTypeIds.LAQ,
    label: "LAQ",
  },
];

const TestConfig = ({
  type = libTypeIds.MCQ,
  testDetails = {},
  setTestDetails,
  errors = {},
  setErrors,
  onChangeName,
  onChangeTopic,
  section = {},
  topicErrors = {},
  isPublished = false,
}) => {
  const { setShowNotify, setIsLoaded } = useAuth();
  const axios = useAxiosPrivate();
  const [sectionName, setSectionName] = useState("");
  // const [topics, setTopics] = useState([]);  GLOBAL TOPICS WILL NOT WORK
  const [subjects, setSubjects] = useState([]);
  const [openToast, setOpenToast] = useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [deleteSecId, setDeleteSecId] = useState(null);
  const [toastType, setToastType] = useState("warning");

  // useEffect(() => {
  //   if (!!errors.sections) {
  //     setOpenToast(true);
  //     setErrorMsg(errors.sections ?? "Please add atleast one section");
  //   } else if (!!errors.section?.[section?.secId]?.topics) {
  //     setOpenToast(true);
  //     setErrorMsg(
  //       errors.section?.[section?.secId]?.topics ??
  //         "Please add atleast one topic"
  //     );
  //   }
  // }, [errors, section]);

  // const debouncedSectionName = useDebouncedValue(sectionName, 500);
  useEffect(() => {
    setSectionName(
      section?.secName ?? `Section - ${testDetails.sections.length + 1}`,
    );
  }, [testDetails, section]);

  /* Api Call */
  useEffect(() => {
    +type === libTypeIds.MCQ && fetchSubjects();
  }, [axios, type, setIsLoaded, setShowNotify]);

  const fetchSubjects = async () => {
    try {
      const response = await axios.get(`node/subject?type=2&isShared=true&all=true`);
      if (response.data.resultCode !== RESULT_STATUS.SUCCESS) {
        throw new Error("Something went wrong while fetching");
      }
      let subjectsData = response.data.data ?? [];
      subjectsData = subjectsData.map((topic) => ({ value: topic.id, label: topic.name }));
      setSubjects(subjectsData);
      return subjectsData;
    } catch (error) {
      console.error("Error fetching Subjects:", error);
      let isUnAuth = error.message.includes("403");
      setShowNotify({
        isUnAuth,
        title: isUnAuth ? "Warning !" : "Error !",
        msg: isUnAuth
          ? "You have been logged-out due to inactivity. Login again."
          : error.message ??
          `Unable to get the topics. Please try again later`,
        show: true,
      });
    }
  }

  const addSection = (event) => {
    event.preventDefault();
    let details = structuredClone(testDetails);
    details.sections = details.sections.map((section) => ({
      ...section,
      isActive: false,
    }));
    details.sections.push({
      secId: nanoid(),
      secName: `Section - ${testDetails.sections.length + 1}`,
      isActive: true,
      status: "new",
      topics: [
        {
          id: nanoid(),
          topicId: null,
          topicName: null,
          configLibType: null,
          languages: [],
          complexityId: null,
          complexityName: null,
          availableQnCount: "",
          randomQnCount: null,
          fixedQnCount: null,
          fixedQnIds: [],
          mark: null,
          duration: null,
          durationUnit: "m",
          status: "new",
          subject: null,
          topics: []
        },
      ],
    });
    setTestDetails(details);
  };

  const onChangeSectionName = (e) => {
    const value = e.target.value;
    setSectionName(value);
    onChangeName && onChangeName(e);
  };

  const onActiveSection = (event, id) => {
    console.log("section id", id);
    event.preventDefault();
    let details = structuredClone(testDetails);
    details.sections = details.sections.map((section) => {
      if (section.secId === id) section.isActive = true;
      else section.isActive = false;
      return section;
    });
    setTestDetails(details);
  };

  const onDeleteSection = async (event, sectionId) => {
    event.stopPropagation();
    let copyDetails = structuredClone(testDetails);
    let section = copyDetails.sections.find((sec) => sec.secId === sectionId);
    console.log("section", section);

    if (section.status === "old") {
      let topics = section.topics.reduce((acc, top) => {
        if (top.status === "old") acc.push(top.id);
        return acc;
      }, []);
      if (topics.length) {
        try {
          setIsLoaded(true);
          const { data } = await axios.post(
            "node/admin/test/testconfig/delete",
            {
              testConfigId: topics,
            },
          );

          if (data.resultCode !== RESULT_STATUS.SUCCESS) {
            setOpenToast(true);
            setErrorMsg("Unable to delete configuration.");
            return;
          }
        } catch (error) {
          console.error("error in get test list", error);
          let isUnAuth = error.message.includes("403");
          setShowNotify({
            isUnAuth,
            title: isUnAuth ? "Warning !" : "Error !",
            msg: isUnAuth
              ? "You have been logged-out due to inactivity. Login again."
              : error.message ??
              `Unable to delete the section. Please try again later`,
            show: true,
          });
          return;
        } finally {
          setIsLoaded(false);
        }
      }
    }
    setTestDetails((prev) => {
      const details = structuredClone(prev);

      const index = details.sections.findIndex(
        (sec) => sec.secId === section.secId,
      );

      // safety check
      if (index === -1) return prev;

      // remove the section
      details.sections.splice(index, 1);

      // reset active states
      details.sections = details.sections.map((sec) => ({
        ...sec,
        isActive: false,
      }));

      // activate nearest section
      if (details.sections.length > 0) {
        const newActiveIndex = index - 1 >= 0 ? index - 1 : 0;

        details.sections[newActiveIndex].isActive = true;
      }

      return details;
    });
    setErrors((prev) => {
      let copy = structuredClone(prev);
      delete copy[1]?.section?.[sectionId];
      return copy;
    });
    setOpenToast(true);
    setErrorMsg("The section is deleted successfully.");
    setToastType("success");
    setOpenPopup(false);
  };

  const addTopic = () => {
    let details = structuredClone(testDetails);
    const section = details.sections.find((sec) => sec.isActive);
    section?.topics?.push({
      id: nanoid(),
      topicId: null,
      topicName: null,
      configLibType: null,
      languages: [],
      complexityId: null,
      complexityName: null,
      availableQnCount: "",
      randomQnCount: null,
      fixedQnCount: null,
      fixedQnIds: [],
      mark: null,
      duration: null,
      durationUnit: "m",
      status: "new",
      subject: null,
      topics: []
    });
    setErrors((prev) => {
      let copy = structuredClone(prev);
      if (!copy[1]?.section) copy[1].section = {};
      if (!copy[1]?.section?.[section.secId])
        copy[1].section[section.secId] = {};
      if (Object.keys(copy[1].section[section.secId]).length) {
        delete copy[1].section[section.secId];
      } else {
        copy[1].section[section.secId].topics = "Please add at least one topic";
      }
      return copy;
    });
    setTestDetails(details);
  };

  const onChangeTopicField = async (id, field, value) => {
    onChangeTopic && onChangeTopic(id, field, value);
  };

  const onDeleteTopic = async (topic) => {
    let details = structuredClone(testDetails);
    const section = details.sections.find((sec) => sec.isActive);
    if (section) {
      if (topic.status === "old") {
        try {
          setIsLoaded(true);
          const { data } = await axios.post(
            "node/admin/test/testconfig/delete",
            {
              testConfigId: topic.id,
            },
          );
          console.log("data", data);
          if (data.resultCode !== RESULT_STATUS.SUCCESS) {
            setOpenToast(true);
            setErrorMsg("Unable to delete configuration.");
            return;
          }
        } catch (error) {
          console.error("error in delete topic", error);

          let isUnAuth = error.message.includes("403");
          setShowNotify({
            isUnAuth,
            title: isUnAuth ? "Warning !" : "Error !",
            msg: isUnAuth
              ? "You have been logged-out due to inactivity. Login again."
              : error.message ??
              `Unable to delete the section. Please try again later`,
            show: true,
          });
          return;
        } finally {
          setIsLoaded(false);
        }
      }

      section.topics = section.topics?.filter((top) => top.id !== topic.id);
    }
    setTestDetails(details);
    setOpenToast(true);
    setErrorMsg("The topic is deleted successfully.");
    setToastType("success");
    setOpenPopup(false);
  };
  console.log("errors?.section?.[section.secId]?.secName", errors?.section);

  return (
    <div className="test-config-container">
      <Toast
        open={openToast}
        onClose={() => setOpenToast(false)}
        message={errorMsg}
        type={toastType}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      // slots={{ transition: Slide }}
      />
      {parseInt(type) !== libTypeIds.CODING_CHALLENGE &&
        parseInt(type) !== libTypeIds.SQL ? (
        <div className={`test-config-sections-container`}>
          {testDetails?.sections?.map((section) => (
            <div
              className={`test-config-section-container${section.isActive ? " active" : ""
                }`}
              key={section.secId}
              onClick={(event) => {
                onActiveSection(event, section.secId);
              }}
            >
              <div className="test-config-section-left-container">
                <p className="test-config-section-title">
                  {section.secName}
                  {Object.keys(errors?.section?.[section.secId] ?? {})
                    ?.length ? (
                    <Tooltip title="Please fill the required fields">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ marginLeft: "8px" }}
                      >
                        <path
                          d="M8 5.99997V8.66664M8 11.3333H8.00667M7.07688 2.59445L1.59362 12.0655C1.28948 12.5909 1.13742 12.8535 1.15989 13.0691C1.1795 13.2571 1.27801 13.428 1.43091 13.5392C1.60622 13.6666 1.90973 13.6666 2.51674 13.6666H13.4833C14.0903 13.6666 14.3938 13.6666 14.5691 13.5392C14.722 13.428 14.8205 13.2571 14.8401 13.0691C14.8626 12.8535 14.7105 12.5909 14.4064 12.0655L8.92312 2.59445C8.62007 2.07101 8.46855 1.80929 8.27087 1.72139C8.09843 1.64471 7.90157 1.64471 7.72913 1.72139C7.53145 1.80929 7.37992 2.07101 7.07688 2.59445Z"
                          stroke="#F79009"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </Tooltip>
                  ) : null}
                </p>
                <p className="test-config-section-topic-count">
                  No. of Topics: {section?.topics?.length ?? 0}
                </p>
              </div>
              <Tooltip title="Delete" isIcon>
                <IconButton
                  hierarchy="tertiaryGrey"
                  destructive={true}
                  onClick={(event) => {
                    event.stopPropagation();
                    setOpenPopup(true);
                    setDeleteSecId(section.secId);
                  }}
                  disabled={isPublished}
                  className="test-config-section-delete-btn"
                >
                  <svg
                    width="15"
                    height="15"
                    viewBox="0 0 15 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.834961 4.16836H2.50163M2.50163 4.16836H15.835M2.50163 4.16836V15.835C2.50163 16.277 2.67722 16.701 2.98978 17.0135C3.30234 17.3261 3.72627 17.5017 4.16829 17.5017H12.5016C12.9437 17.5017 13.3676 17.3261 13.6801 17.0135C13.9927 16.701 14.1683 16.277 14.1683 15.835V4.16836H2.50163ZM5.00163 4.16836V2.50169C5.00163 2.05966 5.17722 1.63574 5.48978 1.32318C5.80234 1.01062 6.22627 0.835022 6.66829 0.835022H10.0016C10.4437 0.835022 10.8676 1.01062 11.1801 1.32318C11.4927 1.63574 11.6683 2.05966 11.6683 2.50169V4.16836M6.66829 8.33502V13.335M10.0016 8.33502V13.335"
                      stroke="#B42318"
                      strokeWidth="1.67"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </IconButton>
              </Tooltip>
            </div>
          ))}
          <Button
            size="sm"
            hierarchy={{ type: "linkGrey", buttonText: "Add Section" }}
            onClick={addSection}
            disable={isPublished}
            icon={{
              icon: (
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.0001 4.16669V15.8334M4.16675 10H15.8334"
                    stroke="#667085"
                    strokeWidth="1.67"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              ),
              type: "leading",
            }}
          />
        </div>
      ) : (
        <div></div>
      )}
      {Object.keys(section).length ? (
        <div
          className={`test-config-section-detail-container${+type === libTypeIds.CODING_CHALLENGE || +type === libTypeIds.SQL
            ? " test-config-section-detail-cc-container"
            : ""
            }`}
        >
          {parseInt(type) !== libTypeIds.CODING_CHALLENGE &&
            parseInt(type) !== libTypeIds.SQL ? (
            <InputField
              label="Section Name"
              name="secName"
              value={sectionName}
              hintText={errors?.section?.[section.secId]?.secName}
              destructive={!!errors?.section?.[section.secId]?.secName}
              onChange={onChangeSectionName}
              placeholder="Enter Section Name"
              className="test-config-section-input-field"
              disabled={isPublished}
            />
          ) : null}
          <div className="test-config-section-detail-config-topic-qns-container">
            {section?.topics?.map((topic, index) => (
              <ConfigureTopic
                type={type}
                key={topic.id}
                topic={topic}
                difficulties={difficulties}
                languages={languages}
                descTypes={descTypes}
                availableQnCount={testDetails.availableQnCount}
                onChange={onChangeTopicField}
                isVideoAssessment={testDetails.videoAssessment}
                index={index}
                onDelete={onDeleteTopic}
                errors={errors?.topics ? errors.topics[topic.id] : {}}
                setErrors={setErrors}
                topicError={topicErrors[topic.id] ?? []}
                isPublished={isPublished}
                subjects={subjects}
                setTestDetails={setTestDetails}
              />
            ))}
            <div className="test-config-section-detail-config-topic-add-btn-container config-topic-add-btn-container">
              <Button
                size="sm"
                hierarchy={{ type: "tertiaryGrey", buttonText: "Add Topic" }}
                disable={isPublished}
                icon={{
                  icon: (
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10.0001 4.16669V15.8334M4.16675 10H15.8334"
                        stroke="#667085"
                        strokeWidth="1.67"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  ),
                  type: "leading",
                }}
                onClick={addTopic}
              />
            </div>
          </div>
          <Modal
            isOpen={openPopup}
            closeIcon={null}
            showCloseIcon={false}
            onClose={() => setOpenPopup(false)}
            className="config-topic-confirmation-modal"
          >
            <ModalBody
              content={
                <>
                  <p className="config-topic-confirmation-modal-title">
                    Delete Section
                  </p>
                  <p className="config-topic-confirmation-modal-content">
                    Are you sure you want to delete the section?
                  </p>
                </>
              }
              footer={
                <div className="config-topic-confirmation-footer">
                  <Button
                    size="sm"
                    hierarchy={{ type: "secondaryGrey", buttonText: "Cancel" }}
                    onClick={() => setOpenPopup(false)}
                  />
                  <Button
                    size="sm"
                    hierarchy={{ type: "primary", buttonText: "Delete" }}
                    destructive={true}
                    onClick={(event) => onDeleteSection(event, deleteSecId)}
                  />
                </div>
              }
            />
          </Modal>
        </div>
      ) : null}
    </div>
  );
};

export default TestConfig;
